import REPORT_DATA from 'constant/REPORT'
import USERS from 'constant/USERS'
import _ from 'underscore'
import { cloneDeep } from 'lodash'

const REPORT = cloneDeep(REPORT_DATA)

export const isForType = (reportType, name) => {
    const field = _.findWhere(REPORT_DATA.fields, { name })
    return field.applicableTypes.indexOf(reportType) !== -1
}

export const getTypeLabel = (value, lang = 'fr', short = false) => {
    const type = _.findWhere(REPORT.types, { value })
    if (short)
        return String(type.shortLabel[lang]) 
    return String(type.label[lang])
}

export const getDataLabel = (name, value, lang = 'fr') => {
    const report = _.findWhere(REPORT.fields, { name })
    let label = ''
    if ((!value && value !== 0) || !report) return label
    try {
        label = String(_.findWhere(report.data, { value }).label[lang])
    } catch(err) {
        //console.log(name, value)
        //if (__SERVER)
        //    console.error(err)
        return label
    }
    return label
}

export const getUser = _id => _.findWhere(USERS, { _id }) || {}

export const multipleCount = data => {
    let count = 0
    data.forEach((value) => value !== 'none' ? count += 1 : null)
    return count
}

export const getFrameCount = (frames, type) => {
    let result = 0
    frames.forEach((frame) => {
        if (frame && frame[type])
            result += frame[type]
    })
    return result
}

export const booleansCount = data => {
    let count = 0
    for (var i in data) {
        if (data[i])
            count += 1
    }
    return count
}
 
export const getReportsByFilters = (reports, filters, search, sort = 'created', sortType = -1) => {
    reports = _.sortBy(reports.filter((report) => {
        let match = true
        if (search && search.key === 'report' && search.value !== report._id) match = false
        else if (search && search.key !== 'report' && report[search.key]._id !== search.value) match = false
       // else {
            for (const i in filters) {
                if (filters[i][0] && filters[i][0] !== undefined) {
                    /*TODO: Uniq method*/
                    if (i === 'states' && filters[i][0] && filters[i].indexOf(report.hive.state) === -1)
                        match = false
                    else if (i === 'clientCountry' && filters[i][0] && filters[i].indexOf(report.client.country) === -1)
                        match = false
                    else if (i !== 'states' && i !== 'clientCountry' && filters[i][0] !== undefined && filters[i].indexOf(report[i]) === -1)
                        match = false
                }
            }
            return match
        //}
    }), sort)
    if (sortType === -1) reports = reports.reverse()
    return reports
}

export const getSelectReportsOptions = (clients, reports) => {
    let hives = []
    let samples = []
    clients.forEach((client) => { 
        hives = hives.concat(client.hives
            .filter((hive) => {
                for (let i = 0; i < reports.length; i++) {
                    if (reports[i].hive && reports[i].hive._id === hive._id)
                        return hive
                }
            })
            .map((hive) => ({ value: hive._id, label: hive.identifier, key: 'hive' }))
        )
    })
    reports.forEach((report) => {
        if (report.sample && report.sampleNumber)
            samples.push({
                value: report._id,
                label: `${report.hive.identifier}-${report.sampleNumber}`,
                key: 'report'
            })
    })
    return [..._.sortBy([
        ...clients
            .filter((client) => {
                for (let i = 0; i < reports.length; i++) {
                    if (reports[i].client && reports[i].client._id === client._id)
                        return client
                }
            })
            .map((client) => ({ value: client._id, label: client.name, key: 'client' })),
        ...hives,
    ], 'label'), ...samples]
}


// WEBPACK FOOTER //
// ./src/client/features/reports/lib.js